module.exports = __webpack_public_path__ + "static/media/OrderPlaced.bb535c6b.gif";